import React, { useState } from 'react';
import { useTheme } from '../../context/ThemeContext';

const ReactionTestGame = () => {
  const { isDark } = useTheme();
  const [reactionTime, setReactionTime] = useState(null);
  const [waiting, setWaiting] = useState(false);
  const [startTime, setStartTime] = useState(null);
  const [results, setResults] = useState([]);

  const startTest = () => {
    setWaiting(true);
    setReactionTime(null);
    
    const randomDelay = 1000 + Math.random() * 4000;
    setTimeout(() => {
      setStartTime(Date.now());
      setWaiting(false);
    }, randomDelay);
  };

  const handleClick = () => {
    if (waiting) {
      setWaiting(false);
      setReactionTime(null);
      alert('Terlalu cepat! Tunggu hingga warna berubah.');
      return;
    }

    if (startTime) {
      const time = Date.now() - startTime;
      setReactionTime(time);
      setResults([...results, time].slice(-5));
      setStartTime(null);
    } else {
      startTest();
    }
  };

  const getAverage = () => {
    if (results.length === 0) return 0;
    return Math.round(results.reduce((a, b) => a + b, 0) / results.length);
  };

  // Theme Token Styles
  const titleClr = isDark ? 'text-white' : 'text-gray-800';
  const textMuted = isDark ? 'text-slate-400' : 'text-gray-600';
  const scoreClr = isDark ? 'text-blue-400' : 'text-blue-600';
  
  // Interactive Box Colors
  let boxBg = isDark ? 'bg-[#111C2C] border-[#1E3A5F]' : 'bg-gray-200 border-[#1E293B]';
  let boxText = isDark ? 'text-slate-200' : 'text-gray-800';

  if (waiting) {
    boxBg = isDark ? 'bg-red-950/80 border-red-500 text-red-200' : 'bg-red-400 text-white';
  } else if (startTime) {
    boxBg = isDark ? 'bg-emerald-950/80 border-emerald-500 text-emerald-200' : 'bg-emerald-400 text-white';
  }

  return (
    <div className="max-w-md mx-auto">
      <h3 className={`text-xl md:text-2xl font-bold text-center mb-6 pixel-font ${titleClr}`}>
        ⚡ REACTION TEST
      </h3>
      
      <div className="mb-6">
        <div 
          className={`pixel-border h-44 flex flex-col items-center justify-center cursor-pointer p-4 text-center select-none transition-colors ${boxBg} ${boxText}`}
          onClick={handleClick}
        >
          <span className="text-3xl mb-2">
            {waiting ? '🛑' : startTime ? '⚡' : '🎯'}
          </span>
          <span className="text-base md:text-lg font-bold pixel-font">
            {waiting 
              ? 'TUNGGU HIJAU...' 
              : startTime 
              ? 'KLIK SEKARANG!' 
              : reactionTime 
              ? 'KLIK UNTUK COBA LAGI' 
              : 'KLIK UNTUK MULAI'}
          </span>
        </div>
      </div>

      {reactionTime && (
        <div className="text-center mb-6 bg-[var(--bg-muted)] p-3 pixel-border">
          <div className={`text-xl font-bold ${scoreClr}`}>
            Waktu Reaksi: {reactionTime} ms
          </div>
          {results.length > 1 && (
            <div className={`text-xs ${textMuted} mt-1`}>
              Rata-rata (5 Terakhir): {getAverage()} ms
            </div>
          )}
        </div>
      )}

      <div className="flex justify-center">
        <button 
          className="pixel-button bg-blue-600 text-white px-6 py-2.5 hover:bg-blue-700 text-xs md:text-sm font-bold pixel-font"
          onClick={startTest}
        >
          TES BARU
        </button>
      </div>
    </div>
  );
};

export default ReactionTestGame;